
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
import * as mapboxgl from 'mapbox-gl/dist/mapbox-gl.js';
import * as MapboxDraw from "@mapbox/mapbox-gl-draw";
import * as MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import * as turf from "@turf/turf";

import * as moment from 'moment';
import { layerSource } from '../mapboxConfig/source.js'
import { setLayerProperties, setLayerProperties3 } from '../../components/layer/layer-data.js'
import { layerProperties } from '../../components/layer/layer-store.js'
import { setToolsMap } from '../../components/toolsMap/toolsMap-data.js'
import { toolsMapInteraction } from '../../components/toolsMap/toolsMap-store.js'
import { setStatus } from '../../components/status/status-data.js'
import { layerStyles } from '../mapboxConfig/styles.js'
import { layerAtributes } from '../mapboxConfig/layerAtributes.js'
import { sourceLayer } from '../mapboxConfig/sourceLayer.js'
import { styleLayer } from '../mapboxConfig/styleLayer.js'
import { treeTools } from '../../components/tree/tree-store.js'
import { setToolTree } from '../../components/tree/tree-data.js'
import { getMapInterval, getMapMunicipio } from '../service/mapas.js'
import { entidadBase2, municipioBase2 } from '../../stores/storymaps.js'
import { onChangeEntidad, onChangeMunicipio } from '../storymaps/index'
import { attributionControl } from '../dom/index'
import { ConstantColorFactor } from 'three';

let map;
let mapRef;
let adminLayer;
let adminIdentify;
let toolsMap;

let timeValues = [];
let marcador = '';

layerProperties.subscribe(prop => {
  adminLayer = prop
});
treeTools.subscribe(prop => {
  adminIdentify = prop
});
toolsMapInteraction.subscribe(prop => {
  toolsMap = prop
});
// Función para capitalizar una cadena
function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}
export const setLayerOpacity = (id, value) => {
  let layers = mapRef.getStyle().layers;
  let layer = layerStyles().find(item => item.id === id);
  let nameLayer = layer['name']
  let typeLayer = layer['typelayer']
  let entitie = layer['entitielayer']
  if (mapRef.getLayer(nameLayer)) {
    if (typeLayer === 'vector') {
      if (entitie === 'point') {
        mapRef.setPaintProperty(nameLayer, 'circle-opacity', value);
        mapRef.setPaintProperty(nameLayer, 'circle-stroke-opacity', value);
      } else if (entitie === 'poligon') {
        mapRef.setPaintProperty(nameLayer, 'fill-opacity', value);
      }
    } else {
      mapRef.setPaintProperty(nameLayer, 'raster-opacity', value);
    }
  }
  return
}
export const setVectorOpacity = (id, value) => {
  try {
    let nameLayer = id
    if (mapRef.getLayer(nameLayer)) {
      let type = mapRef.getLayer(nameLayer)['type']
      if (type === 'circle') {
        mapRef.setPaintProperty(nameLayer, 'circle-opacity', value);
        mapRef.setPaintProperty(nameLayer, 'circle-stroke-opacity', value);
      } else if (type === 'fill') {
        mapRef.setPaintProperty(nameLayer, 'fill-opacity', value);
        mapRef.setPaintProperty(`${nameLayer}_outline`, 'line-opacity', value);
      }
    }
    return
  } catch (err) {
    console.log(err)
  }
}
export const setHistoricOpacity = (id, value) => {
  let nameLayer = id
  let typeLayer = 'vector'
  let entitie = 'point'
  if (mapRef.getLayer(nameLayer)) {
    if (typeLayer === 'vector') {
      if (entitie === 'point') {
        mapRef.setPaintProperty(nameLayer, 'circle-opacity', value);
        mapRef.setPaintProperty(nameLayer, 'circle-stroke-opacity', value);
      } else if (entitie === 'poligon') {
        mapRef.setPaintProperty(nameLayer, 'fill-opacity', value);
      }
    } else {
      mapRef.setPaintProperty(nameLayer, 'raster-opacity', value);
    }
  }
  return
}
export const centerPoint = (lng, lat, zoom) => {
  try {
    mapRef.flyTo({
      center: [lng, lat],
      zoom: zoom,
    });
    return
  } catch (err) {
    console.log(err)
  }
}
export const centrar = (param) => {
  if (param['lng'] === null && param['lat'] === null) {
    marcador != '' ? marcador.remove() : null
    return
  }
  if (param['lng'] === 0 && param['lat'] === 0) {
    let { lng, lat } = mapRef.getCenter();
    toolsMap[0]['goLongitud'] = lng.toFixed(6)
    toolsMap[0]['goLatitud'] = lat.toFixed(6)
    return
  }
  let coordinates = [param['lng'], param['lat']]
  mapRef.flyTo({
    center: coordinates,
    zoom: param['zoom'],
  });
  marcador != '' ? marcador.remove() : null
  marcador = new mapboxgl.Marker({
    draggable: true,
    color: 'black',
    rotation: 45
  })
    .setLngLat([param['lng'], param['lat']])
    .addTo(mapRef);
  function onDragEnd() {
    const lngLat = marcador.getLngLat();
    toolsMap[0]['goLongitud'] = lngLat.lng.toFixed(6)
    toolsMap[0]['goLatitud'] = lngLat.lat.toFixed(6)
    let pt = turf.point([lngLat.lng, lngLat.lat]);
    let converted = turf.toMercator(pt);
  }
  marcador.on('dragend', onDragEnd);
}
export const addLayer2 = (id) => {
  let layers = mapRef.getStyle().layers;
  let layerBase = ''
  if (layers.length >= 1) {
    layerBase = layers[1]['id']
  } else {
    layerBase = layers[0]['id']
  }

  let layerName = layerStyles().filter(item => item.id === id)
  if (layerName.length != 0) {
    mapRef.addLayer(layerName[0]['layer'], layerBase);
    mapRef.removeLayer(layers[0]['id']);
  }
  return
}
export const addLayer3 = (id) => {
  let layers = mapRef.getStyle().layers;
  let configLayer = layerStyles().find(item => item.id === 4)
  let opacity = adminLayer.find(item => item.id === 4)['opacity']
  mapRef.fire('closeAllPopups');
  changeBbox(id)
  mapRef.removeLayer('pcalor');
  mapRef.removeSource('pcalor')
  mapRef.addSource('pcalor', {
    'type': 'vector',
    'tiles': [
      `http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/${id}/{z}/{x}/{y}.pbf`
    ],
    'minzoom': 2,
    'maxzoom': 11
  });
  mapRef.addLayer(configLayer['layer'])
  setLayerOpacity(4, opacity / 100)
  return
}
export const addLayer4 = (id) => {
  if (mapRef.getLayer('pcalordia')) {
    //console.log('Fintrando capas...');
    mapRef.fire('closeAllPopups');
    let opacity = adminLayer.find(item => item.id === 4)['opacity'];
    mapRef.setFilter('pcalordia', ['in', 'd0', id]);
    setLayerOpacity(4, opacity / 100);
    if (mapRef.getLayer('goes_points')) {
      mapRef.setFilter('goes_points', ['in', 'id_pais', id]);
      let opacity = adminLayer.find(item => item.id === 105)['opacity'];
      setLayerOpacity(105, opacity / 100);
    }
    if ( mapRef.getLayer('goes_heatmap') || mapRef.getLayer('goes_heatmap_points')) {
      mapRef.setFilter('goes_heatmap', ['in', 'id_pais', id]);
      mapRef.setFilter('goes_heatmap_points', ['in', 'id_pais', id]);
      let opacity = adminLayer.find(item => item.id === 106)['opacity'];
      setLayerOpacity(106, opacity / 100);
    }
    if (mapRef.getLayer('goes_fdcf_10min')) {
      mapRef.setFilter('goes_fdcf_10min', ['in', 'id_pais', id]);
      let opacity = adminLayer.find(item => item.id === 108)['opacity'];
      setLayerOpacity(108, opacity / 100);
    }
    if ( mapRef.getLayer('goes_fdcf_heatmap') || mapRef.getLayer('goes_fdcf_heatmap_points')) {
      mapRef.setFilter('goes_fdcf_heatmap', ['in', 'id_pais', id]);
      mapRef.setFilter('goes_fdcf_heatmap_points', ['in', 'id_pais', id]);
      let opacity = adminLayer.find(item => item.id === 109)['opacity'];
      setLayerOpacity(109, opacity / 100);
    }
    if (mapRef.getLayer('rave')) {
      mapRef.setFilter('rave', ['in', 'id_pais', id]);
      let opacity = adminLayer.find(item => item.id === 120)['opacity'];
      setLayerOpacity(120, opacity / 100);
    }
    if (mapRef.getLayer('rave_24h')) {
      mapRef.setFilter('rave_24h', ['in', 'id_pais', id]);
      let opacity = adminLayer.find(item => item.id === 121)['opacity'];
      setLayerOpacity(121, opacity / 100);
    }
    changeBbox(id)
    return
  }
}
export const addLayerGeneral = (id) => {
  let capas = layerStyles();
  let layers = mapRef.getStyle().layers;
  let opacity = adminLayer.find(item => item.id === id)['opacity']

  setLayerProperties3(id, 'selected', !adminLayer.find(item => item.id === id)['selected'])
  capas.forEach(function (item) {
    if (id === item['id']) {
      let layer = item['layer']['id']
      let configLayer = item['layer']
      if (mapRef.getLayer(layer)) {
        mapRef.removeLayer(layer);
        mapRef.fire('closeAllPopups');
      } else {
        setStatus('activeLayer', id)
        if (item['name'] === 'pcalordia' || layers.find(item => item.id === 'pcalordia') === undefined) {
          mapRef.addLayer(configLayer);
          setLayerOpacity(id, opacity / 100)
        } else {
          mapRef.addLayer(configLayer);
          mapRef.getLayer('googleHybrid') ? mapRef.moveLayer('googleHybrid') : null
          mapRef.getLayer('estados') ? mapRef.moveLayer('estados') : null
          mapRef.getLayer('anp') ? mapRef.moveLayer('anp') : null
          mapRef.getLayer('rave_24h') ? mapRef.moveLayer('rave_24h') : null
          mapRef.getLayer('rave') ? mapRef.moveLayer('rave') : null
          mapRef.getLayer('goes_fdcf_heatmap_points') ? mapRef.moveLayer('goes_fdcf_heatmap_points') : null
          mapRef.getLayer('goes_fdcf_heatmap') ? mapRef.moveLayer('goes_fdcf_heatmap') : null
          mapRef.getLayer('goes_fdcf_10min') ? mapRef.moveLayer('goes_fdcf_10min') : null
          mapRef.getLayer('goes_heatmap_points') ? mapRef.moveLayer('goes_heatmap_points') : null
          mapRef.getLayer('goes_heatmap') ? mapRef.moveLayer('goes_heatmap') : null
          mapRef.getLayer('goes_points') ? mapRef.moveLayer('goes_points') : null
          mapRef.getLayer('pcalordia') ? mapRef.moveLayer('pcalordia') : null
          setLayerOpacity(id, opacity / 100)
        }
      }
    }
  });
  return
}

export const addLayerTvector = (id) => {
  let urlName = id;
  let layers = mapRef.getStyle().layers;
  setToolsMap('layerMeasure', id)
  setToolsMap('layerLast', id)
  if (layers.find(item => item.id === id) === undefined) {
    mapRef.addSource(id, {
      'type': 'vector',
      "scheme": "tms",
      'tiles': [
        `http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/historico/${urlName}/{z}/{x}/{y}.pbf?update="${Math.random()}"`
      ],
      'minzoom': 2,
      'maxzoom': 14
    });
    mapRef.fire('closeAllPopups');
    mapRef.addLayer({
      'id': id,
      'type': 'fill',
      'layout': {
        'visibility': 'visible'
      },
      'source': id,
      'source-layer': id,
      'paint': {
        'fill-color': '#fe992e',
        'fill-opacity': .4
      }
    })
    mapRef.addLayer({
      'id': `${id}_outline`,
      'type': 'line',
      'layout': {
        'visibility': 'visible'
      },
      'source': id,
      'source-layer': id,
      'paint': {
        'line-color': '#fe992e',
        'line-width': 3
      }
    })

  } else {
    mapRef.setLayoutProperty(id, 'visibility', 'visible')
    mapRef.setLayoutProperty(`${id}_outline`, 'visibility', 'visible')
  }
  return
}
export const addLayerTvector2 = (id, cve, group) => {
  let layers = mapRef.getStyle().layers;
  let source = sourceLayer().find(item => item.layer === id)['source']
  let style = styleLayer().find(item => item.layer === id)['style']


  deleteIdentify()
  if (toolsMap[0]['layerMeasure'] === '') {
    setToolsMap('layerMeasure', id)
  }
  setToolsMap('layerLast', id)
  setToolTree(id, 'selected', true)
  setToolTree(id, 'identify', true)
  setToolTree(id, 'name', id)
  setToolTree(id, 'config', false)
  setToolTree(id, 'group', group)
  setToolTree(id, 'id', cve)

  if (layers.find(item => item.id === id) === undefined) {

    mapRef.addSource(id, source);
    mapRef.fire('closeAllPopups');
    if (id != 'pcalordia') {

      mapRef.addLayer(style, 'pcalordia')
    } else {

      mapRef.addLayer(style)
      mapRef.moveLayer(id)
    }
  } else {

    mapRef.setLayoutProperty(id, 'visibility', 'visible')
    mapRef.moveLayer(id)
    mapRef.getLayer('estados') ? mapRef.moveLayer('estados') : null
    mapRef.getLayer('anp') ? mapRef.moveLayer('anp') : null
    mapRef.getLayer('aqmodis') ? mapRef.moveLayer('aqmodis') : null
    mapRef.getLayer('aqmodis_outline') ? mapRef.moveLayer('aqmodis_outline') : null
    mapRef.getLayer('rave_24h') ? mapRef.moveLayer('rave_24h') : null
    mapRef.getLayer('rave') ? mapRef.moveLayer('rave') : null
    mapRef.getLayer('goes_fdcf_heatmap_points') ? mapRef.moveLayer('goes_fdcf_heatmap_points') : null
    mapRef.getLayer('goes_fdcf_heatmap') ? mapRef.moveLayer('goes_fdcf_heatmap') : null
    mapRef.getLayer('goes_fdcf_10min') ? mapRef.moveLayer('goes_fdcf_10min') : null
    mapRef.getLayer('goes_heatmap_points') ? mapRef.moveLayer('goes_heatmap_points') : null
    mapRef.getLayer('goes_heatmap') ? mapRef.moveLayer('goes_heatmap') : null
    mapRef.getLayer('goes_points') ? mapRef.moveLayer('goes_points') : null
    mapRef.getLayer('pcalordia') ? mapRef.moveLayer('pcalordia') : null
  }
  if (adminIdentify.filter(item => item.selected === true).length !== 0 && toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
    setToolsMap('layerMeasure', toolsMap[0]['layerMeasure'])
  }
  return ''
}
export const addLayerTvector3 = (id, cve, group) => {
  deleteIdentify()
  setToolsMap('layerLast', id)

  setToolTree(id, 'selected', true)
  setToolTree(id, 'identify', true)
  setToolTree(id, 'name', id)
  setToolTree(id, 'config', false)
  setToolTree(id, 'group', group)
  setToolTree(id, 'id', cve)
  setToolTree(id, 'layer', id)
  if (adminIdentify.filter(item => item.selected === true).length !== 0 && toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
    setToolsMap('layerMeasure', toolsMap[0]['layerMeasure'])
  }

}
export const addLayerTvector4 = (id, cve, group) => {
  let layers = mapRef.getStyle().layers;
  let urlName = id;
  deleteIdentify()
  if (toolsMap[0]['layerMeasure'] === '') {
    setToolsMap('layerMeasure', id)
  }
  setToolsMap('layerLast', id)
  setToolTree(id, 'selected', true)
  setToolTree(id, 'identify', true)
  setToolTree(id, 'name', id)
  setToolTree(id, 'config', false)
  setToolTree(id, 'group', group)
  setToolTree(id, 'id', cve)

  if (layers.find(item => item.id === id) === undefined) {

    mapRef.addSource(id, {
      'type': 'vector',
      "scheme": "tms",
      'tiles': [
        `http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/vtiles/${urlName}/{z}/{x}/{y}.pbf?update="${Math.random()}"`
      ],
      'minzoom': 2,
      'maxzoom': 14
    });
    mapRef.fire('closeAllPopups');
    if (id != 'pcalordia') {

      mapRef.addLayer({
        'id': `${id}_outline`,
        'type': 'line',
        'layout': {
          'visibility': 'visible'
        },
        'source': id,
        'source-layer': id,
        'paint': {
          'line-color': '#fe992e',
          'line-width': 3
        }
      }, 'pcalordia')
    } else {


      mapRef.addLayer({
        'id': `${id}_outline`,
        'type': 'line',
        'layout': {
          'visibility': 'visible'
        },
        'source': id,
        'source-layer': id,
        'paint': {
          'line-color': '#fe992e',
          'line-width': 3
        }
      })
      mapRef.moveLayer(id)
    }
  } else {

    mapRef.setLayoutProperty(id, 'visibility', 'visible')
    mapRef.setLayoutProperty(`${id}_outline`, 'visibility', 'visible')
    mapRef.moveLayer(id)
    mapRef.getLayer('estados') ? mapRef.moveLayer('estados') : null
    mapRef.getLayer('anp') ? mapRef.moveLayer('anp') : null
    mapRef.getLayer('aqmodis') ? mapRef.moveLayer('aqmodis') : null
    mapRef.getLayer('rave_24h') ? mapRef.moveLayer('rave_24h') : null
    mapRef.getLayer('rave') ? mapRef.moveLayer('rave') : null
    mapRef.getLayer('goes_fdcf_heatmap_points') ? mapRef.moveLayer('goes_fdcf_heatmap_points') : null
    mapRef.getLayer('goes_fdcf_heatmap') ? mapRef.moveLayer('goes_fdcf_heatmap') : null
    mapRef.getLayer('goes_fdcf_10min') ? mapRef.moveLayer('goes_fdcf_10min') : null
    mapRef.getLayer('goes_heatmap_points') ? mapRef.moveLayer('goes_heatmap_points') : null
    mapRef.getLayer('goes_heatmap') ? mapRef.moveLayer('goes_heatmap') : null
    mapRef.getLayer('goes_points') ? mapRef.moveLayer('goes_points') : null
    mapRef.getLayer('pcalordia') ? mapRef.moveLayer('pcalordia') : null
  }
  if (adminIdentify.filter(item => item.selected === true).length !== 0 && toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
    setToolsMap('layerMeasure', toolsMap[0]['layerMeasure'])
  }
  return ''
}
export const pruebasource = (id) => {

  let nameSource = ['', 'estados', 'estados2', 'estados3', 'estados4', 'estados5', 'estados6', 'estados7', 'estados8', 'estados9']
  let urlSourse = `http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/vtiles/${nameSource[id]}/{z}/{x}/{y}.pbf`
  mapRef.getSource('estados').tiles = [urlSourse]
  mapRef.style.sourceCaches['estados'].clearTiles()
  mapRef.style.sourceCaches['estados'].update(mapRef.transform)
}
export const pruebasource2 = (id) => {
  let nameSource = ['', 'municipios', 'municipios2', 'municipios3', 'municipios4', 'municipios5', 'municipios6', 'municipios7', 'municipios8', 'municipios9']
  let urlSourse = `http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/vtiles/${nameSource[id]}/{z}/{x}/{y}.pbf`
  mapRef.getSource('estados').tiles = [urlSourse]
  mapRef.style.sourceCaches['estados'].clearTiles()
  mapRef.style.sourceCaches['estados'].update(mapRef.transform)
}
export const addLayerHistoric = async (id) => {
  let urlName = id.replace('h', '');
  let annio = urlName.split('_')[1]
  if (!toolsMap[0]['toolsMeasure']) {
    setToolTree(id, 'identify', true)
  }

  setToolsMap('layerLast', id)
  let layers = mapRef.getStyle().layers;
  if (layers.find(item => item.id === id) === undefined) {
    mapRef.addSource(id, {
      'type': 'vector',
      "scheme": "tms",
      'tiles': [
        `http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/historico/${urlName}/{z}/{x}/{y}.pbf?update="${Math.random()}"`
      ],
      'minzoom': 2,
      'maxzoom': 7
    });
    let layerStyle = {
      'id': id,
      'type': 'circle',
      'layout': {
        'visibility': 'visible'
      },
      'source': id,
      /*filter: [
        "all",
        ['>=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 00:00:00`, "YYYY-MM-DD HH:mm:ss").unix()],
        ['<=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 23:59:59`, "YYYY-MM-DD HH:mm:ss").unix()]
      ],*/
      'source-layer': `pcalor_${annio}`,
      //'filter': ['in', 'd0', 1],
      'paint': {
        'circle-color': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          'blue',
          [
            'match',
            ['get', 'f15'],
            1,
            '#FFD37F',
            3,
            '#38A800',
            4,
            '#4CE600',
            5,
            '#00C5FF',
            6,
            '#FFFFFF',
            7,
            '#9BDE00',
            8,
            '#008A9E',
            9,
            '#FFFFFF',
            10,
            '#7D990F',
            11,
            '#7D990F',
            12,
            '#FFFF00',
            13,
            '#A900FF',
            14,
            '#F770FF',
            15,
            '#FFFFFF',
            16,
            '#D44C00',
            17,
            '#E39C1C',
            18,
            '#E1E1E1',
        /* other */ '#ccc'
          ]
        ],
        //'circle-radius': 2,
        'circle-radius': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          3,
          2
        ],
        'circle-stroke-width': .5,
        'circle-stroke-color': [
          'match',
          ['get', 'f15'],
          1,
          '#FFD37F',
          3,
          '#38A800',
          4,
          '#4CE600',
          5,
          '#00C5FF',
          6,
          '#FFFFFF',
          7,
          '#9BDE00',
          8,
          '#008A9E',
          9,
          '#FFFFFF',
          10,
          '#7D990F',
          11,
          '#7D990F',
          12,
          '#FFFF00',
          13,
          '#A900FF',
          14,
          '#F770FF',
          15,
          '#FFFFFF',
          16,
          '#D44C00',
          17,
          '#E39C1C',
          18,
          '#E1E1E1',
        /* other */ '#ccc'
        ]
        /*'circle-stroke-color': [
          'match',
          ['get', 'tipo'],
          'diurno',
          'red',
          'nocturno',
          '#000000',
          '#ccc'
        ]*/
      }
    }
    mapRef.fire('closeAllPopups');
    mapRef.addLayer(layerStyle)

  } else {
    mapRef.setLayoutProperty(id, 'visibility', 'visible')
  }

  return ''
}
export const deleteLayerHistoric = (id) => {
  let layers = mapRef.getStyle().layers;
  if (layers.find(item => item.id === id) !== undefined) {
    mapRef.setLayoutProperty(id, 'visibility', 'none');
  }
  deleteIdentify();
  mapRef.fire('closeAllPopups');
  setToolTree(id, 'selected', false);
  setToolTree(id, 'identify', false);
  setToolTree(id, 'config', false);
  if (adminIdentify.filter(item => item.selected === true).length !== 0) {
    if (toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
      let layers = adminIdentify.filter(item => item.selected === true && item.layer !== id)
      if (toolsMap[0]['layerMeasure'] === id) {
        setToolsMap('layerMeasure', layers[0]['layer'])
        updateLayerArea()
      }
    }
  } else {
    if (toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
      deleteDrawPoligon()
      setToolsMap('toolsMeasure', false);
      setToolsMap('typeMeasure', '')
    }
  }
  return
}
export const deleteLayerTvector = (id) => {
  let layers = mapRef.getStyle().layers;
  mapRef.fire('closeAllPopups');
  if (adminIdentify.find(item => item.layer === id && item.identify)) {
    deleteIdentify()
  }
  if (layers.find(item => item.id === id) !== undefined) {
    mapRef.setLayoutProperty(id, 'visibility', 'none')
  }
  if (layers.find(item => item.id === `${id}_outline`) !== undefined) {
    mapRef.setLayoutProperty(`${id}_outline`, 'visibility', 'none')
  }
  return
}
export const deleteLayerTvector2 = (id) => {
  let layers = mapRef.getStyle().layers;
  deleteIdentify()
  mapRef.fire('closeAllPopups');
  setToolTree(id, 'selected', false)
  setToolTree(id, 'identify', false)
  setToolTree(id, 'config', false)
  if (layers.find(item => item.id === id) !== undefined) {
    mapRef.setLayoutProperty(id, 'visibility', 'none')
  }
  if (layers.find(item => item.id === `${id}_outline`) !== undefined) {
    mapRef.setLayoutProperty(`${id}_outline`, 'visibility', 'none')
  }
  if (adminIdentify.filter(item => item.selected === true).length !== 0) {
    if (toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
      let layers = adminIdentify.filter(item => item.selected === true && item.layer !== id)

      if (toolsMap[0]['layerMeasure'] === id) {
        setToolsMap('layerMeasure', layers[0]['layer'])
        updateLayerArea()
      }
    }
  } else {
    if (toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
      deleteDrawPoligon()
      setToolsMap('toolsMeasure', false);
      setToolsMap('typeMeasure', '')
    }
  }
  return
}
export const deleteLayerTvector3 = (id) => {
  deleteIdentify()
  mapRef.fire('closeAllPopups');
  setToolTree(id, 'selected', false)
  setToolTree(id, 'identify', false)
  setToolTree(id, 'config', false)

  if (adminIdentify.filter(item => item.selected === true).length !== 0) {
    if (toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
      let layers = adminIdentify.filter(item => item.selected === true && item.layer !== id)

      if (toolsMap[0]['layerMeasure'] === id) {
        setToolsMap('layerMeasure', layers[0]['layer'])
        updateLayerArea()
      }
    }
  }
  if (adminIdentify.filter(item => item.selected === true).length !== 0 && toolsMap[0]['typeMeasure'] === 'draw_polygon' || toolsMap[0]['typeMeasure'] === 'simple_select') {
    setToolsMap('layerMeasure', toolsMap[0]['layerMeasure'])
  }
  return
}
export const deleteLayerFilter = (id) => {
  mapRef.removeLayer(id);
  mapRef.removeSource(id)
  return
}
export const addStyleFilter = (id) => {
  mapRef.addSource(id, {
    'type': 'vector',
    "scheme": "tms",
    'tiles': [
      `http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/historico/${id}/{z}/{x}/{y}.pbf?update="${Math.random()}"`
    ],
    'minzoom': 2,
    'maxzoom': 11
  });
  let layerStyle = {
    'id': id,
    'type': 'circle',
    'layout': {
      'visibility': 'visible'
    },
    'source': id,
    'source-layer': 'pcalor_2021',

    'paint': {
      'circle-color': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        'blue',
        [
          'match',
          ['get', 'f1'],
          'd',
          '#ebed04',
          'n',
          'red',
        /* other */ '#ccc'
        ]
      ],
      'circle-radius': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        3,
        2
      ],
      'circle-stroke-width': .5,
      'circle-stroke-color': [
        'match',
        ['get', 'f1'],
        'd',
        '#ebed04',
        'n',
        'red',
        /* other */ '#ccc'
      ]
    }
  }
  mapRef.fire('closeAllPopups');
  mapRef.addLayer(layerStyle)
  return
}
export const setFilterVisibility = (status) => {
  let property = 'none'
  if (status) {
    property = 'visible'
  }
  timeValues.forEach((item, index) => {
    mapRef.setLayoutProperty(item, 'visibility', property)
  })
}
export const setFilterOpacity = (value) => {
  timeValues.forEach((item, index) => {
    mapRef.setPaintProperty(item, 'circle-opacity', value)
    mapRef.setPaintProperty(item, 'circle-stroke-opacity', value)
  })
}
export const addLayerFilter = (dateIni, dateEnd) => {
  if (timeValues.length > 0) {
    timeValues.forEach((item, index) => {
      deleteLayerFilter(item)
      timeValues = []
    })
  }
  dateIni = moment(dateIni[0]);
  dateEnd = moment(dateEnd[0]);
  let filtroIni = dateIni.format('YYYY-MM-DD')
  let filtroEnd = dateEnd.format('YYYY-MM-DD')
  while (dateEnd > dateIni || dateIni.format('M') === dateEnd.format('M')) {
    timeValues.push(`pcalor${dateIni.format('MM_YYYY')}`);
    dateIni.add(1, 'month');
  }

  timeValues.forEach((item, index) => {
    addLayerGroup(item)
    mapRef.setFilter(item, [
      "all",
      ['>=', 'f4', moment.utc(filtroIni + " 00:00:00").unix()],
      ['<=', 'f4', moment.utc(filtroEnd + " 23:59:59").unix()]
    ]);
    mapRef.getLayer(item).setPaintProperty('circle-color', [
      'match',
      ['get', 'f5'],
      moment(filtroEnd).subtract(0, 'days').format('YYYY-MM-DD'),
      '#800026',
      moment(filtroEnd).subtract(1, 'days').format('YYYY-MM-DD'),
      '#bd0026',
      moment(filtroEnd).subtract(2, 'days').format('YYYY-MM-DD'),
      '#e31a1c',
      moment(filtroEnd).subtract(3, 'days').format('YYYY-MM-DD'),
      '#fc4e2a',
      moment(filtroEnd).subtract(4, 'days').format('YYYY-MM-DD'),
      '#fd8d3c',
      moment(filtroEnd).subtract(5, 'days').format('YYYY-MM-DD'),
      '#feb24c',
      moment(filtroEnd).subtract(6, 'days').format('YYYY-MM-DD'),
      '#fed976',
      moment(filtroEnd).subtract(7, 'days').format('YYYY-MM-DD'),
      '#ffeda0',
      moment(filtroEnd).subtract(8, 'days').format('YYYY-MM-DD'),
      '#ffffcc',
      '#808080'
    ])
    mapRef.getLayer(item).setPaintProperty('circle-stroke-color', [
      'match',
      ['get', 'f5'],
      moment(filtroEnd).subtract(0, 'days').format('YYYY-MM-DD'),
      '#800026',
      moment(filtroEnd).subtract(1, 'days').format('YYYY-MM-DD'),
      '#bd0026',
      moment(filtroEnd).subtract(2, 'days').format('YYYY-MM-DD'),
      '#e31a1c',
      moment(filtroEnd).subtract(3, 'days').format('YYYY-MM-DD'),
      '#fc4e2a',
      moment(filtroEnd).subtract(4, 'days').format('YYYY-MM-DD'),
      '#fd8d3c',
      moment(filtroEnd).subtract(5, 'days').format('YYYY-MM-DD'),
      '#feb24c',
      moment(filtroEnd).subtract(6, 'days').format('YYYY-MM-DD'),
      '#fed976',
      moment(filtroEnd).subtract(7, 'days').format('YYYY-MM-DD'),
      '#ffeda0',
      moment(filtroEnd).subtract(8, 'days').format('YYYY-MM-DD'),
      '#ffffcc',
      '#808080'
    ])
  })
}
export const addLayerGroup = (id) => {
  let annio = id.split('_')[1]
  let layers = mapRef.getStyle().layers;
  if (layers.find(item => item.id === id) === undefined) {
    mapRef.addSource(id, {
      'type': 'vector',
      "scheme": "tms",
      'tiles': [
        `http://ec2-34-220-247-76.us-west-2.compute.amazonaws.com/map/tiles3/${id}/{z}/{x}/{y}.pbf`
        //`http://ec2-54-186-103-125.us-west-2.compute.amazonaws.com/map/tiles3/${id}/{z}/{x}/{y}.pbf`
      ],
      'minzoom': 2,
      'maxzoom': 12
    });
    let layerStyle = {
      'id': id,
      'type': 'circle',
      'layout': {
        'visibility': 'visible'
      },
      'source': id,
      'source-layer': `pcalor_${annio}`,
      'paint': {
        'circle-color': 'red',
        'circle-radius': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          3,
          2
        ],
        'circle-stroke-width': .5,
        'circle-stroke-color': 'red'
      }
    }
    mapRef.fire('closeAllPopups');
    mapRef.addLayer(layerStyle)
  } else {
    mapRef.setLayoutProperty(id, 'visibility', 'visible')
  }
  return
}
export const changeLayerUrl = (id) => {
  let capas = layerStyles()
  let url = `http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/${id}/{z}/{x}/{y}.pbf`
  capas.forEach(function (item) {
    if (item['id'] === 4) {
      let layer = item['idcapa']
      if (map.hasLayer(layer)) {
        layer.setUrl(url);
      } else {
        addLayerGeneral(4);
        setLayerProperties(4);
        setTimeout(() => {
          layer.setUrl(url);
        }, 1000)
      }
    }
  });
  return
}
export const changeFilter = (param) => {
  let layers = mapRef.getStyle().layers;
  let configLayer = layerStyles().find(item => item.id === 32)
  let opacity = adminLayer.find(item => item.id === 32)['opacity']

  function formato(value) {
    let fecha = value.split('/')
    return `${fecha[2]}-${fecha[1]}-${fecha[0]}`
  }
  let dateEnd = formato(param['dateEnd'])
  if (layers.find(item => item.id === 'pcalorfiltro') === undefined) {
    mapRef.addLayer(configLayer['layer'])
    setLayerOpacity(4, opacity / 100)
  }
  mapRef.setFilter('pcalorfiltro', [
    "all",
    ['>=', 'f4', moment.utc(formato(param['dateIni']) + " 00:00:00").unix()],
    ['<=', 'f4', moment.utc(formato(param['dateEnd']) + " 23:59:59").unix()]
  ]);
  mapRef.getLayer('pcalorfiltro').setPaintProperty('circle-color', [
    'match',
    ['get', 'f5'],
    moment(dateEnd).subtract(0, 'days').format('YYYY-MM-DD'),
    '#800026',
    moment(dateEnd).subtract(1, 'days').format('YYYY-MM-DD'),
    '#bd0026',
    moment(dateEnd).subtract(2, 'days').format('YYYY-MM-DD'),
    '#e31a1c',
    moment(dateEnd).subtract(3, 'days').format('YYYY-MM-DD'),
    '#fc4e2a',
    moment(dateEnd).subtract(4, 'days').format('YYYY-MM-DD'),
    '#fd8d3c',
    moment(dateEnd).subtract(5, 'days').format('YYYY-MM-DD'),
    '#feb24c',
    moment(dateEnd).subtract(6, 'days').format('YYYY-MM-DD'),
    '#fed976',
    moment(dateEnd).subtract(7, 'days').format('YYYY-MM-DD'),
    '#ffeda0',
    moment(dateEnd).subtract(8, 'days').format('YYYY-MM-DD'),
    '#ffffcc',
    /* other */ '#808080'
  ])
}
export const changeFilter2 = (param) => {
  let configLayer = layerStyles().find(item => item.id === 4);
  let opacity = adminLayer.find(item => item.id === 4)['opacity']
  mapRef.addLayer(configLayer['layer'])
  setLayerOpacity(4, opacity / 100)
  mapRef.getLayer('pcalor').setPaintProperty('circle-color', [
    'match',
    ['get', 'tipo'],
    'diurno',
    '#ebed04',
    'nocturno',
    'blue',
    /* other */ '#ccc'
  ])
}

export const changeFilter3 = async (annio, pais, estado, intervalTipo, intervalNum, opcion, nivel, sensor, pcFiltro) => {
  try {
    let dataPcalor = []
    let keyProperty = 'id_estado'
    if (nivel === 1) {
      dataPcalor = await getMapInterval({ annio, pais, intervalTipo, intervalNum, sensor, pcFiltro })
    } else if (nivel === 2) {
      dataPcalor = await getMapMunicipio({ annio, pais, estado, intervalTipo, intervalNum, sensor, pcFiltro })
      keyProperty = 'id_mun'
    }
    let data = []
    if (opcion === 1) {
      data = dataPcalor
    }
    const matchExpression = ['match', ['get', keyProperty]];
    for (const row of data) {
      matchExpression.push(row['code'], row['color']);
    }
    matchExpression.push('rgba(101, 99, 100, 1)');
    mapRef.setPaintProperty('estados', 'fill-color', matchExpression);
    return ''
  } catch (err) {
    console.log(err)
  }
}
export const layerShowToggle = (id) => {
  let layerName = adminLayer.find(item => item.id === id)['idname']
  let visibility = mapRef.getLayoutProperty(
    layerName,
    'visibility'
  );
  if (visibility === 'visible') {
    mapRef.setLayoutProperty(
      layerName,
      'visibility',
      'none'
    );
  } else {
    mapRef.setLayoutProperty(
      layerName,
      'visibility',
      'visible'
    );
  }
}
export const mapAction = async (container, param) => {
  mapRef = createMap2(container)
  return {
    update: (param) => {
    },
    destroy: () => {
      mapRef.remove()
      mapRef = null;
    }
  };
}
export const exportFormat = () => {
  function convertToCSV(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    array = array['features']
    let result = array.map((item, index) => {
      let properties = item['properties']
      let geometry = item['geometry']['coordinates']
      let lat = geometry[0]
      let lng = geometry[1]
      let { tipo, id, fecha, d1, d2, d3, d4, d5, d6, d9, d10 } = properties
      return [`'${tipo}'`, `'${id}'`, `'${moment.unix(d10).format('DD-MM-YYYY')}'`, `'${moment.unix(d10).format('HH:mm:ss')}'`, `'${d1}'`, `'${d2}'`, `'${d3}'`, `'${d4}'`, `'${d5}'`, `'${d6}'`, `'${d9}'`, `'${lng}'`, `'${lat}'`]
    })
    result.unshift('Tipo,Id,Fecha,Hora,País,Estado,Municipio,Vegetación,Área natural afectada,Pendiente,Satélite,Latitud,Longitud')
    return result.join('\r\n');
  }
  function convertToKML(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    array = array['features']
    let result = array.map((item, index) => {
      let properties = item['properties']
      let geometry = item['geometry']['coordinates']
      let lat = geometry[0]
      let lng = geometry[1]
      let { tipo, id, fecha, d0, d1, d2, d3, d4, d5, d6, d8, d9, d10 } = properties
      return `
          <Placemark>
              <ExtendedData>
              <SchemaData schemaUrl="#pcalor">
                  <SimpleData name="Tipo">${tipo}</SimpleData>
                  <SimpleData name="Id">${id}</SimpleData>
                  <SimpleData name="Fecha">${moment.unix(d10).format('DD-MM-YYYY')}</SimpleData>
                  <SimpleData name="Hora">${moment.unix(d10).format('HH:mm:ss')}</SimpleData>
                  <SimpleData name="País">${d1}</SimpleData>
                  <SimpleData name="Estado">${d2}</SimpleData>
                  <SimpleData name="Municipio">${d3}</SimpleData>
                  <SimpleData name="Vegetación">${d4}</SimpleData>
                  <SimpleData name="Área natural afectada">${d5}</SimpleData>
                  <SimpleData name="Pendiente">${d6}</SimpleData>
                  <SimpleData name="Satélite">${d9}</SimpleData>
                  <SimpleData name="Fecha">${d10}</SimpleData>
                  <SimpleData name="Longitud">${lng}</SimpleData>
                  <SimpleData name="Latitud">${lat}</SimpleData>
              </SchemaData>
              </ExtendedData>
              <Point>
                  <coordinates>${lat},${lng}</coordinates>
              </Point>
          </Placemark>
          `
    })
    let kmlBase = `<?xml version="1.0" encoding="utf-8" ?>
      <kml xmlns="http://www.opengis.net/kml/2.2">
      <Document id="root_doc">
      <Schema name="" id="pcalor">
      <SimpleField name="Tipo" type="string"></SimpleField>
      <SimpleField name="Id" type="int"></SimpleField>
      <SimpleField name="Fecha" type="string"></SimpleField>
      <SimpleField name="Hora" type="string"></SimpleField>
      <SimpleField name="País" type="string"></SimpleField>
      <SimpleField name="Estado" type="string"></SimpleField>
      <SimpleField name="Municipio" type="string"></SimpleField>
      <SimpleField name="Vegetación" type="string"></SimpleField>
      <SimpleField name="Área natural afectada" type="string"></SimpleField>
      <SimpleField name="Pendiente" type="string"></SimpleField>
      <SimpleField name="Satélite" type="string"></SimpleField>
      <SimpleField name="Longitud" type="float"></SimpleField>
      <SimpleField name="Latitud" type="float"></SimpleField>
      </Schema>
      <Folder><name>ejemplo</name>
      ${result}
      </Folder>
      </Document></kml>`
    return kmlBase
  }
  let geojson = toolsMap[0]['downloadGeojson']

  let convertedData = ''
  if (toolsMap[0]['fileDownload'] === 'csv') {
    convertedData = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(convertToCSV(geojson));
  } else if (toolsMap[0]['fileDownload'] === 'txt') {
    convertedData = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(convertToCSV(geojson));
  } else if (toolsMap[0]['fileDownload'] === 'kml') {
    convertedData = 'data:application/vnd.google-earth.kml+xml;charset=utf-8,' + encodeURIComponent(convertToKML(geojson));
  } else if (toolsMap[0]['fileDownload'] === 'geojson') {
    let geojsonProperties = geojson['features']
    let propertiesFormat = geojsonProperties.map(function (item, id) {
      let format = {
        type: item['type'],
        properties: (function () {
          let properties = item['properties']
          let format = {}
          for (const property in properties) {
            format = {
              'Tipo': properties['tipo'],
              'Id': properties['id'],
              'Fecha': moment.unix(properties['d10']).format('DD-MM-YYYY'),
              'Hora': moment.unix(properties['d10']).format('HH:mm:ss'),
              'País': properties['d1'],
              'Estado': properties['d2'],
              'Municipio': properties['d3'],
              'Vegetación': properties['d4'],
              'Área natural afectada': properties['d5'],
              'Pendiente': properties['d6'],
              'Satélite': properties['d9'],
              'Longitud': properties['lon'],
              'Latitud': properties['lat']
            }
          }
          return format
        }()),
        geometry: item['geometry']
      }
      return format
    })
    geojson['features'] = propertiesFormat
    convertedData = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(geojson));
  }
  setToolsMap('downloadPolygon', convertedData)
}
function spatialJoin(featuresPoint, featurePolygon, opcion) {
  try {
    let joined = featuresPoint.filter((feature) => {
      let sourceGeoJSON = feature.geometry.coordinates
      let point = turf.point(sourceGeoJSON)
      return turf.booleanPointInPolygon(point, featurePolygon);
    })
    let resultGeojson = []
    if (opcion === 1) {
      resultGeojson = joined.map((item, id) => {
        return {
          type: item['type'],
          properties: item['properties'],
          geometry: item['_geometry']
        }
      })
    } else if (opcion === 2) {
      resultGeojson = joined.map((item, id) => {
        return {
          type: item['type'],
          properties: function () {
            return {
              d1: item['properties']['f6'],
              d2: item['properties']['f7'],
              d3: item['properties']['f8'],
              d4: item['properties']['f10'],
              d5: item['properties']['f12'],
              d6: item['properties']['f13'],
              d9: item['properties']['f14'],
              d10: item['properties']['f4'],
              fecha: item['properties']['f5'],
              id: item['properties']['id'],
              lat: item['properties']['f3'],
              lon: item['properties']['f2'],
              tipo: function () { return item['properties']['f1'] === 'n' ? 'nocturno' : 'diurno' }()
            }
          }(),
          //properties:item['properties'],
          geometry: item['_geometry']
        }
      })
    }

    setToolsMap('countPolygon', joined.length)
    let geojson = {
      "type": "FeatureCollection",
      "features": resultGeojson
    }
    setToolsMap('downloadGeojson', geojson)

    exportFormat()
    return
  } catch (err) {
    console.log(err)
  }
}
export const createMap2 = (contenedor2) => {
  mapboxgl.accessToken = `pk.eyJ1IjoiZ2VvYWJyYWhhbWNnIiwiYSI6ImNqbHpnY3VhNzB3Z2gzcG10anV6NmtwMGYifQ.GRSGfCucg-8moMpnF3ba7Q`;

  // Create the map
  let map = new mapboxgl.Map({
    container: contenedor2,
    maxZoom: 16,
    style: {
      'version': 8,
      'sources': {
        'raster-tiles': {
          'type': 'raster',
          'tiles': [
            'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.jpg'
          ],
          'tileSize': 256,
          'attribution':
            'Map tiles by <a target="_top" rel="noopener" href="http://stamen.com">Stamen Design</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a target="_top" rel="noopener" href="http://openstreetmap.org">OpenStreetMap</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
        }
      },
      'layers': [
        {
          'id': 'simple-tiles',
          'type': 'raster',
          'source': 'raster-tiles',
          'minzoom': 0,
          'maxzoom': 22
        }
      ]
    },
    center: [-102.209477, 24.153438],
    zoom: 4.9
  });

  map.on('sourcedata', () => {
    if (map.getSource('pcalorfiltro') && map.isSourceLoaded('pcalorfiltro')) {
    }
  });

  let popup3
  let popup4
  map['boxZoom'].enable();
  let draw = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      polygon: true,
      line_string: true,
      trash: true
    }
    //defaultMode: 'draw_polygon'
  });
  map.addControl(draw, 'top-left');

  map.on('draw.create', updateArea);
  map.on('draw.delete', updateArea);
  map.on('draw.update', updateArea);
  map.on('draw.actionable', (e) => {
    const data = draw.getAll();
    setToolsMap('typeMeasure', draw.getMode())
    if (data.features.length > 1) {
      //draw.deleteAll()
      draw.delete(data.features[0]['id'])
    }
    if (draw.getMode() == 'draw_line_string') {
      setToolsMap('areaMeasure', 0)
    } else if (draw.getMode() == 'draw_polygon') {
      setToolsMap('distanceMeasure', 0)
      updateArea(e);
    }
  });

  //map.on('draw.render', updateArea);
  map.on('getArea', () => {
    let featuresPoint = map.queryRenderedFeatures({ layers: [toolsMap[0]['layerMeasure']] });
    let featurePolygon = toolsMap[0]['polygonMeasure']
    spatialJoin(featuresPoint, featurePolygon, 1)
  });
  map.on('deleteDrawPoligon', () => {
    draw
      .deleteAll()
  });

  /*function updateArea(e) {
    try {
      const data = draw.getAll();
      setToolsMap('typeMeasure', draw.getMode())
      setToolsMap('areaMeasure', 0)
      if (e.type === 'draw.delete') {
        setToolsMap('distanceMeasure', 0)
        setToolsMap('areaMeasure', 0)
        setToolsMap('typeMeasure', '')
      }
      if (data.features.length > 0) {
        let type = turf.getType(data['features'][0])
        let feature = data['features'][0]
        setToolsMap('polygonMeasure', feature)
        if (type === 'LineString') {
          let distancia = turf.length(feature, { units: 'kilometers' }).toFixed(3)
          if (distancia < 1) {
            setToolsMap('distanceMeasure', `${turf.length(feature, { units: 'meters' }).toFixed(3)} m`)
          } else {
            setToolsMap('distanceMeasure', `${turf.length(feature, { units: 'kilometers' }).toFixed(3)} km`)
          }
        } else if (type === 'Polygon') {
          let area = turf.area(data);
          let areaKm = area / 1000000
          let areaHa = area / 10000
          if (areaKm >= 1) {
            setToolsMap('areaMeasure', `${areaKm.toFixed(3)} km²`)
          } else if (areaHa >= 1) {
            setToolsMap('areaMeasure', `${area.toFixed(3)} m² <br> ${areaHa.toFixed(3)} ha`)
          } else {
            setToolsMap('areaMeasure', `${area.toFixed(3)} m²`)
          }
          if (toolsMap[0]['layerMeasure'] !== 'pcalorFiltro') {
            let featuresPoint = map.queryRenderedFeatures({ layers: [toolsMap[0]['layerMeasure']] });
            spatialJoin(featuresPoint, feature, 1)
          } else {
            let featuresPoint = [[], [], []]
            timeValues.forEach((item, index) => {
              featuresPoint[index] = map.queryRenderedFeatures({ layers: [item] });
            })
            let a = featuresPoint[0];
            let total = a.concat(featuresPoint[1], featuresPoint[2])
            spatialJoin(total, feature, 2)
          }
        }
        // Create export
      } else {
        if (e.type !== 'draw.delete')
          alert('Click the map to draw a polygon.');
      }
    } catch (err) {
      console.log(err)
    }
  }*/
  function updateArea(e) {
    const data = draw.getAll();
    setToolsMap('typeMeasure', draw.getMode());
    setToolsMap('areaMeasure', 0);
  
    if (e.type === 'draw.delete') {
      setToolsMap('distanceMeasure', 0);
      setToolsMap('areaMeasure', 0);
      setToolsMap('typeMeasure', '');
    }
  
    if (data.features.length > 0) {
      const feature = data.features[0];
      setToolsMap('polygonMeasure', feature);
      const type = turf.getType(feature);
  
      if (type === 'LineString') {
        const distanciaKm = turf.length(feature, { units: 'kilometers' }).toFixed(3);
        const distanciaM = turf.length(feature, { units: 'meters' }).toFixed(3);
        const distancia = distanciaKm >= 1 ? `${distanciaKm} km` : `${distanciaM} m`;
        setToolsMap('distanceMeasure', distancia);
      } else if (type === 'Polygon') {
        const area = turf.area(feature);
        const areaKm = area / 1000000;
        const areaHa = area / 10000;
        let areaMeasure = `${area.toFixed(3)} m²`;
        
        if (areaKm >= 1) {
          areaMeasure = `${areaKm.toFixed(3)} km²`;
        } else if (areaHa >= 1) {
          areaMeasure = `${area.toFixed(3)} m² <br> ${areaHa.toFixed(3)} ha`;
        }
  
        setToolsMap('areaMeasure', areaMeasure);
  
        if (toolsMap[0]['layerMeasure'] !== 'pcalorFiltro') {
          const featuresPoint = map.queryRenderedFeatures({ layers: [toolsMap[0]['layerMeasure']] });
          spatialJoin(featuresPoint, feature, 1);
        } else {
          const featuresPoint = [[], [], []];
          timeValues.forEach((item, index) => {
            featuresPoint[index] = map.queryRenderedFeatures({ layers: [item] });
          });
          const total = featuresPoint[0].concat(featuresPoint[1], featuresPoint[2]);
          spatialJoin(total, feature, 2);
        }
      }
  
      // Create export
    } else {
      if (e.type !== 'draw.delete') {
        alert('Click the map to draw a polygon.');
      }
    }
  }
  
  const popup = new mapboxgl.Popup();
  const canvas = map.getCanvasContainer();
  function onMove(e) {
    canvas.style.cursor = 'grabbing';
  }
 map.on('load', async function () {
    try {
      map.resize();
      layerSource(map)
      addLayerTvector2('pcalordia', 4, 'pcalorBase')
      attributionControl(toolsMap['attributionMap'])
      document.querySelector('.mapboxgl-ctrl-top-left').style.left = '322px';
      document.querySelector('.mapboxgl-ctrl-top-left').style.visibility = 'hidden'
      if (document.querySelector('.mapboxgl-ctrl-top-left') !== null) {
        //container.querySelector('.mapboxgl-ctrl-top-left').style.opacity=0.6;
        document.querySelector('.mapboxgl-ctrl-top-left').style.left = '322px';
        document.querySelector('.mapboxgl-ctrl-top-left').style.top = '60px';
        if (document.querySelector('.mapbox-gl-draw_line') !== null) {
          document.querySelector(".mapbox-gl-draw_ctrl-draw-btn.mapbox-gl-draw_line").setAttribute("title", "Medición de distancias")
          document.querySelector(".mapbox-gl-draw_ctrl-draw-btn.mapbox-gl-draw_polygon").setAttribute("title", "Selección espacial")
          document.querySelector(".mapbox-gl-draw_ctrl-draw-btn.mapbox-gl-draw_trash").setAttribute("title", "Borrar")
        }
      }
      let popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        anchor: 'bottom',
        className: 'poup1'
      });
      let popup2 = new mapboxgl.Popup({
        closeButton: true,
        closeOnClick: false,
        anchor: 'right',
        className: 'poup2'
      });
      let popup3 = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        anchor: 'bottom',
        className: 'poup3'
      });
      popup4 = new mapboxgl.Popup({
        closeButton: true,
        closeOnClick: false,
        anchor: 'bottom',
        className: 'poup4'
      });
      map.on('closeAllPopups', () => {
        popup.remove();
        popup2.remove()
        popup3.remove()
        popup4.remove()
      });
      let marker2 = new mapboxgl.Marker({ color: 'red', rotation: 45, anchor: 'center', offset: [0, 0] })

      let featureIdSelected = { id: null, source: '', sourceLayer: '' }
      map.on('touchstart', (e) => {

        //map.once('touchend', onUp);
        map.once('touchend', (e) => {


          let layerName, features, typeEntity, id

        })
      })

      // Evento 'click' en el mapa
      map.on('click', function (e) {
        try {
          const selectedAdminIdentify = adminIdentify.filter(item => item.selected === true && item.identify === true);
          if (selectedAdminIdentify.length !== 0) {
            const { layer: layerName, id } = selectedAdminIdentify[0];

            if (map.getLayer(layerName)) {
              const features = map.queryRenderedFeatures(e.point, { layers: [layerName] });

              if (features.length) {
                const feature = features[0];

                if (layerName === 'estados') {
                  findEntidad(layerName, feature.id);
                  setToolsMap('entitySelected', feature.properties['id_estado']);

                  if (!toolsMap[0]['statusMunicipios']) {
                    setToolsMap('entidadBase', feature.properties['id_estado']);
                    setToolsMap('nivelAdminFilter', 2);
                    entidadBase2.update(prop => {
                      return feature.properties['id_estado'];
                    });
                    onChangeEntidad();
                    setToolsMap('statusMunicipios', true);
                  } else {
                    setToolsMap('municipioNom', feature.properties['nom_mun']);
                    setToolsMap('municipioBase', feature.properties['id_mun']);
                    setToolsMap('nivelAdminFilter', 3);
                    municipioBase2.update(prop => {
                      return feature.properties['id_mun'];
                    });
                    onChangeMunicipio();
                  }
                }

                // Resto del código para obtener atributos y configurar el popup
                let getAtributes = layerAtributes().find(item => item.id === id);
                let htmlAtributes = []

                getAtributes['properties'].forEach(function (item, index) {
                  let atribute = feature.properties[item['key']]
                  if (item['type'] === 'date') {
                    if (moment.unix(atribute).format('DD-MM-YYYY') !== 'Invalid date') {
                      atribute = moment.unix(atribute).format('DD-MM-YYYY');
                    }
                  } else if (item['type'] === 'hours') {
                    atribute = moment.unix(atribute).format('HH:mm:ss')
                  } else if (item['type'] === 'string') {
                    atribute = capitalize(atribute)
                  } else if (item['type'] === 'number') {
                    function isInt(n) {
                      return Number(n) === n && n % 1 === 0;
                    }
                    atribute = isInt(atribute) ? parseInt(atribute) : parseFloat(atribute)
                  }
                  htmlAtributes.push(`<div style="white-space: normal;">${item['name']}: ${atribute} </div>`)
                })

                // Actualizar el contenido del popup
                const description = `
                  <div class="block-title" style="margin-top: 5px;margin-bottom: 5px;font-size:var(--f7-font-size);">${getAtributes['name']}</div>
                  <div class="list simple-list" style="margin-top: 5px!important;margin-bottom: 0px;margin-top: 20px;font-size: var(--f7-font-size);">
                    ${htmlAtributes.join('\n')}
                  </div>
                `;

                popup4.setLngLat(e.lngLat).setHTML(description).addTo(map);

                // Estilos del popup
                const popupContent = document.querySelector(".mapboxgl-popup-content");
                const popupCloseButton = document.querySelector(".mapboxgl-popup-content .mapboxgl-popup-close-button");
                const popupTip = document.querySelector(".mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip");
                
                popupTip.style.opacity = 0.6;
                popupContent.style.opacity = 0.6;
                popupContent.style.color = 'var(--f7-list-item-title-text-color)';
                popupContent.style.background = 'var(--f7-list-bg-color)';
                popupCloseButton.style.backgroundColor = 'var(--f7-list-bg-color)';
                popupCloseButton.style.color = 'var(--f7-list-item-title-text-color)';
                popupCloseButton.style.width = '25px';
                popupCloseButton.style.height = '22px';
                popupCloseButton.style.fontSize = 'large';
                popupCloseButton.style.paddingLeft = '0px';
                popupCloseButton.style.paddingRight = '0px';
              }
            }
          }
        } catch (err) {
          console.log('event onclick', err);
        }
      });

      map.on('mousemove', function (e) {
        try {

          let coord = e.lngLat.wrap()

          function insertLineBreaks(texto, longitudMaxima) {
            let palabras = texto.split(' ');
            let resultado = '';
            let lineaActual = '';

            for (let i = 0; i < palabras.length; i++) {
              let palabra = palabras[i];

              if (lineaActual.length + palabra.length > longitudMaxima) {
                resultado += lineaActual.trim() + '<br>';
                lineaActual = '';
              }

              lineaActual += palabra + ' ';
            }

            resultado += lineaActual.trim();

            return resultado;
          }
          setToolsMap('latitud', coord.lat.toFixed(6))
          setToolsMap('longitud', coord.lng.toFixed(6))
          const center = map.getCenter();
          let longitud = center.lng.toFixed(6);
          let latitud = center.lat.toFixed(6);
          setToolsMap('centerMap', { longitud, latitud })
          let zoom = map.getZoom().toFixed(2);
          let layerName, features, layers;
          let propertiesLayer = adminIdentify.find(item => item.identify === true) !== undefined ? adminIdentify.find(item => item.identify === true) : 'none'

          if (propertiesLayer !== 'none' && propertiesLayer.selected === true && propertiesLayer.identify === true && propertiesLayer.id === 32) {

            let layersFilter = timeValues
            let featuresFilter = map.queryRenderedFeatures(e.point, { layers: layersFilter });
            map.getCanvas().style.cursor = featuresFilter.length ? 'help' : '';
            if (featuresFilter.length !== 0) {
              let atributesFilter = layerAtributes().find(item => item.id === 32);
              let feature = featuresFilter[0]
              let htmlAtributes = []
              atributesFilter['properties'].forEach(function (item, index) {
                let atribute = feature.properties[item['key']]
                if (item['type'] === 'date') {
                  if (moment.unix(atribute).format('DD-MM-YYYY') !== 'Invalid date') {
                    atribute = moment.unix(atribute).format('DD-MM-YYYY');
                  }
                } else if (item['type'] === 'hours') {
                  atribute = moment.unix(atribute).format('HH:mm:ss')
                } else if (item['type'] === 'string') {

                  if (item['name'] === 'Tipo') {
                    atribute = atribute === 'd' ? 'Diurno' : 'Nocturno'
                  }
                  atribute = capitalize(atribute)
                } else if (item['type'] === 'number') {
                  function isInt(n) {
                    return Number(n) === n && n % 1 === 0;
                  }
                  atribute = isInt(atribute) ? parseInt(atribute) : parseFloat(atribute)
                }
                htmlAtributes.push(`<div style="white-space: normal;">${item['name']}: ${atribute} </div>`)
              })
              let description = `
                <div class="block-title" style="margin-top: 5px;margin-bottom: 5px;font-size:var(--f7-font-size);">${atributesFilter['name']}</div>
                <div class="list simple-list" style="margin-top: 5px!important;margin-bottom: 0px;margin-top: 20px;font-size: var(--f7-font-size);">
                  ${htmlAtributes.join('\n')}
                </div>
              `;
              setToolsMap('identifyHtml', description)
            }
            else {
              setToolsMap('identifyHtml', ``)
            }
          } else if (propertiesLayer !== 'none' && propertiesLayer.selected === true && propertiesLayer.identify === true && propertiesLayer.id !== 32) {

            layerName = propertiesLayer.layer
            if (map.getLayer(layerName)) {
              layers = [layerName]
              propertiesLayer.outline ? layers.push(layerName + '_outline') : '';
              features = map.queryRenderedFeatures(e.point, { layers });
              map.getCanvas().style.cursor = features.length ? 'help' : '';
              let getAtributes = layerAtributes().find(item => item.id === propertiesLayer.id);
              if (features.length !== 0) {
                let feature = features[0]
                let htmlAtributes = []
                getAtributes['properties'].forEach(function (item, index) {

                  let atribute = feature.properties[item['key']]
                  if (item['type'] === 'date') {
                    if (moment.unix(atribute).format('DD-MM-YYYY') !== 'Invalid date') {
                      atribute = moment.unix(atribute).format('DD-MM-YYYY');
                    }
                  } else if (item['type'] === 'hours') {
                    atribute = moment.unix(atribute).format('HH:mm:ss')
                  } else if (item['type'] === 'string') {

                    if (item['name'] === 'País' || item['name'] === 'Estado' || item['name'] === 'Municipio') {
                      atribute = atribute.replace(/\b\[a-záéíóúüñÁÉ]/g, (l) => l.toUpperCase())
                    } else {
                      atribute = capitalize(atribute)
                    }
                    atribute = insertLineBreaks(atribute, 16);
                  } else if (item['type'] === 'number') {
                    function isInt(n) {
                      return Number(n) === n && n % 1 === 0;
                    }
                    atribute = isInt(atribute) ? parseInt(atribute) : parseFloat(atribute)
                  }
                  htmlAtributes.push(`<div style="white-space: normal;">${item['name']}: ${atribute} </div>`)
                })
                let description = `
                  <div class="block-title" style="margin-top: 5px;margin-bottom: 5px;font-size:var(--f7-font-size);">${getAtributes['name']}</div>
                  <div class="list simple-list" style="margin-top: 5px!important;margin-bottom: 0px;margin-top: 20px;font-size: var(--f7-font-size);">
                    ${htmlAtributes.join('\n')}
                  </div>
                `;
                setToolsMap('identifyHtml', description)
              }
              else {
                setToolsMap('identifyHtml', ``)
              }
            }
          } else {
            setToolsMap('identifyHtml', '')
          }
        } catch (err) {
          console.log('event mousemove', err)
        }
      })
      map.on('mouseleave', function () {
        map.getCanvas().style.cursor = '';
        popup.remove();
      });
      map.on('mouseenter', 'pcalorfiltro', function (e) {
        try {
          map.getCanvas().style.cursor = 'pointer';
          map.getCanvas().style.color = 'blue';
          let coordinates = e.features[0].geometry.coordinates.slice();
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.add.lng > coordinates[0] ? 360 : -360;
          }
          let properties = e.features[0].properties;

          let date = moment.unix(properties.f4).utc()
          let date2 = moment.unix(properties.f4)

          let cutText = function (text) {
            let textFinal = text
            if (text.length >= 20) {
              textFinal = `${text.substring(24, 0)}...`
            }
            return textFinal
          }
          let description = `
              <div class="block-title" style="margin-top: 5px;margin-bottom: 5px;font-size:var(--f7-menu-font-size);">Puntos de calor/Filtro</div>
              <div class="list simple-list" style="margin-top: 5px!important;margin-bottom: 0px;margin-top: 20px;font-size: var(--f7-font-size);">
                <ul>
                  <li style="height: 26px;">Fecha: ${date2.format('DD-MM-YYYY')}</li>
                  <li style="height: 26px;">Hora: ${date2.format('HH:mm:ss') + ' (local)'} </li>
                  <li style="height: 26px;">Tipo: ${properties.f2 === 'n' ? 'Nocturno' : 'Diurno'}</li>
                </ul>
              </div>
            `;
          popup3.setLngLat(coordinates).setHTML(description).addTo(map);
          document.querySelector(".mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip").style.opacity = 0.6
          document.querySelector(".mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip").style['border-top-color'] = 'var(--f7-list-bg-color)';
          document.querySelector(".mapboxgl-popup-content").style.opacity = 0.6
          document.querySelector(".mapboxgl-popup-content").style.color = 'var(--f7-list-item-title-text-color)'
          document.querySelector(".mapboxgl-popup-content").style.background = 'var(--f7-list-bg-color)';

        } catch (err) {
          console.log('event mouseenter', err)
        }
      })
    } catch (err) {
      console.log(err)
    }
  });
  map.on('mouseleave', 'pcalorfiltro', function () {
    map.getCanvas().style.cursor = '';
    popup3.remove();
  });

  map.addControl(new mapboxgl.NavigationControl());
  map.addControl(new mapboxgl.ScaleControl({ position: 'top-left' }));
  map.addControl(new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl: mapboxgl, 
    placeholder: 'Buscar lugar',
    collapsed: true,
    marker: false,
    position:'top-right',
    limit:3
  }));
  return map
}

export const updateLayerArea = () => {
  mapRef.fire('draw.update')
}
export const addGeojson = (m, param) => {
  let geojson = param['geojson']
  let jsonLayer = L.geoJson(geojson, {
    style: {
      "color": "white",
      "weight": 5,
      "opacity": 1,
      "fillColor": "white",
      "fillOpacity": 0
    },
    onEachFeature: function (feature, layer) {

    }
  })
  jsonLayer.addTo(m);
  m.fitBounds(jsonLayer.getBounds());
}
export const resizeMap = () => {
  if (mapRef) {
    setTimeout(() => {
      mapRef.resize()
    }, 1)
  }
}
export const deleteDrawPoligon = () => {
  mapRef.fire('deleteDrawPoligon');
}
export const getBboxView = (layer) => {
  try {
    let resultGeojson = []
    if (layer === 'pcalordia') {
      resultGeojson = mapRef.queryRenderedFeatures({ layers: [layer] }).map((item, id) => {
        item['properties']['idpoint'] = item['id']
        item['properties']['coordinates'] = item['geometry']['coordinates']
        item['properties']['source'] = item['source']

        return item['properties']
      })
    } else {
      resultGeojson = mapRef.queryRenderedFeatures({ layers: timeValues }).map((item, id) => {
        item['properties']['d1'] = item['properties']['f6']
        item['properties']['d2'] = item['properties']['f7']
        item['properties']['d3'] = item['properties']['f8']
        item['properties']['d4'] = item['properties']['f10']
        item['properties']['d5'] = item['properties']['f12']
        item['properties']['d6'] = item['properties']['f13']
        item['properties']['d9'] = item['properties']['f14']
        item['properties']['d10'] = item['properties']['f4']
        item['properties']['lat'] = item['properties']['f3']
        item['properties']['lon'] = item['properties']['f2']

        item['properties']['idpoint'] = item['id']
        item['properties']['coordinates'] = item['geometry']['coordinates']
        item['properties']['source'] = item['source']

        return item['properties']
      })
    }
    setToolsMap('pointsBbox', resultGeojson)
    return resultGeojson
  } catch (err) {
    console.log(err)
  }
}
export const findEntidad = (layerName, id, property) => {
  try {
    let layers = mapRef.getStyle().layers;
    let typeLayer = mapRef.getLayer(layerName).type;
    let { source, sourceLayer } = mapRef.getLayer(layerName)
    let propertyFind = property || '$id'
    mapRef.fire('closeAllPopups');

    let styles = {
      circle: {
        'id': `identify-${layerName}`,
        'type': 'circle',
        'layout': {
          'visibility': 'visible'
        },
        'source': source,
        'source-layer': sourceLayer,
        'paint': {
          "circle-color": "blue"
        },
        filter: ['==', propertyFind, id]
      },
      fill: {
        'id': `identify-${layerName}`,
        'type': 'line',
        'layout': {
          'visibility': 'visible'
        },
        'source': source,
        'source-layer': sourceLayer,
        'paint': {
          'line-color': 'blue',
          'line-width': 3
        },
        filter: ['==', propertyFind, id]
      }
    }
    if (layers.find(item => item.id === `identify-${layerName}`) === undefined) {
      mapRef.addLayer(styles[typeLayer]);
    } else {
      mapRef.setFilter(`identify-${layerName}`, ['==', propertyFind, id])
      mapRef.moveLayer(`identify-${layerName}`)
    }
    return id
  } catch (err) {
    console.log('error findEntidad', err)
    return
  }

}
export const findEntidad2 = (layerName, id, property) => {
  let layers = mapRef.getStyle().layers;
  if (layers.find(item => item.id === `${layerName}`) !== undefined) {
    if (id === null) {
      mapRef.setFilter(layerName, null)
    } else {
      mapRef.setFilter(layerName, ['==', property, id])
    }
  };
}
export const deleteIdentify = () => {
  let layers = mapRef.getStyle().layers;
  console.log(layers)
  mapRef.fire('closeAllPopups');
  let layerName = ''

  if (mapRef.getLayer(`identify-${layerName}`)) {
    mapRef.setFilter(`identify-${layerName}`, ['==', '$id', ''])
  }
}
export const changeBbox = (id) => {
  let paisBbox = [
    { id: 1, idname: 'MX', name: 'México', bbox: [-117.12776, 14.5388286402, -86.811982388, 32.72083] },
    { id: 2, idname: 'US', name: 'United States', bbox: [-125.0011, 24.9493, -66.9326, 49.5904] },
    { id: 3, idname: 'GT', name: 'Guatemala', bbox: [-92.2292486234, 13.7353376327, -88.2250227526, 17.8193260767] },
    { id: 4, idname: 'BZ', name: 'Belice', bbox: [-89.2291216703, 15.8869375676, -88.1068129138, 18.4999822047] },
    { id: 5, idname: 'HN', name: 'Honduras', bbox: [-89.3533259753, 12.9846857772, -83.147219001, 16.0054057886] },
    { id: 6, idname: 'SV', name: 'El Salvador', bbox: [-90.0955545723, 13.1490168319, -87.7235029772, 14.4241327987] },
    { id: 7, idname: 'NI', name: 'Nicaragua', bbox: [-87.6684934151, 10.7268390975, -83.147219001, 15.0162671981] },
    { id: 8, idname: 'CR', name: 'Costa Rica', bbox: [-85.94172543, 8.22502798099, -82.5461962552, 11.2171192489] },
    { id: 9, idname: 'CR', name: 'Panáma', bbox: [-82.9657830472, 7.2205414901, -77.2425664944, 9.61161001224] }
  ]
  let bbox = paisBbox.find(item => item.id == id)['bbox']
  mapRef.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]])
}
export const changeBbox2 = (id) => {
  let entidadBbox = [
    { id_estado: "1-0", bbox: [-118.407649, 15.686094, -86.710405, 32.446050] },
    { id_estado: "1-1", bbox: [-102.874177, 21.622266, -101.835289, 22.459590] },
    { id_estado: "1-10", bbox: [-107.210133, 22.345084, -102.472698, 26.844876] },
    { id_estado: "1-11", bbox: [-102.097032, 19.912750, -99.671303, 21.839417] },
    { id_estado: "1-12", bbox: [-102.184352, 16.315953, -98.007276, 18.887847] },
    { id_estado: "1-13", bbox: [-99.859541, 19.597758, -97.984930, 21.398521] },
    { id_estado: "1-14", bbox: [-105.695405, 18.925872, -101.510541, 22.750245] },
    { id_estado: "1-15", bbox: [-100.613091, 18.366943, -98.596866, 20.285867] },
    { id_estado: "1-16", bbox: [-103.738127, 17.914908, -100.063032, 20.394556] },
    { id_estado: "1-17", bbox: [-99.494414, 18.332373, -98.632946, 19.131702] },
    { id_estado: "1-18", bbox: [-105.760359, 20.603221, -103.720895, 23.084503] },
    { id_estado: "1-19", bbox: [-101.206762, 23.162683, -98.421577, 27.799137] },
    { id_estado: "1-2", bbox: [-117.124269, 27.999999, -112.764929, 32.718654] },
    { id_estado: "1-20", bbox: [-98.552707, 15.657169, -93.867427, 18.669688] },
    { id_estado: "1-21", bbox: [-99.070493, 17.860912, -96.724683, 20.839960] },
    { id_estado: "1-22", bbox: [-100.596537, 20.015018, -99.043080, 21.670006] },
    { id_estado: "1-23", bbox: [-89.296562, 17.893986, -86.740540, 21.589522] },
    { id_estado: "1-24", bbox: [-102.296039, 21.160154, -98.325967, 24.491522] },
    { id_estado: "1-25", bbox: [-109.447692, 22.467134, -105.392219, 27.042306] },
    { id_estado: "1-26", bbox: [-115.053022, 26.296988, -108.424271, 32.493913] },
    { id_estado: "1-27", bbox: [-94.130024, 17.250893, -90.987458, 18.650965] },
    { id_estado: "1-28", bbox: [-100.144950, 22.206966, -97.144224, 27.679126] },
    { id_estado: "1-29", bbox: [-98.708400, 19.105072, -97.625440, 19.728917] },
    { id_estado: "1-3", bbox: [-115.082308, 22.871954, -109.413173, 28.000001] },
    { id_estado: "1-30", bbox: [-98.681548, 17.136965, -93.607940, 22.471751] },
    { id_estado: "1-31", bbox: [-90.407018, 19.551174, -87.533145, 21.625088] },
    { id_estado: "1-32", bbox: [-104.353534, 21.041870, -100.742324, 25.125235] },
    { id_estado: "1-4", bbox: [-92.468789, 17.812871, -89.121229, 20.848327] },
    { id_estado: "1-5", bbox: [-103.960002, 24.542684, -99.843119, 29.880024] },
    { id_estado: "1-6", bbox: [-104.690586, 18.684156, -103.486347, 19.512519] },
    { id_estado: "1-7", bbox: [-94.139155, 14.532098, -90.370215, 17.985288] },
    { id_estado: "1-8", bbox: [-109.074886, 25.558844, -103.306768, 31.784486] },
    { id_estado: "1-9", bbox: [-99.364923, 19.048237, -98.940304, 19.592757] },
    { id_estado: "2-1", bbox: [-88.472031, 30.217247, -84.893486, 35.008881] },
    { id_estado: "2-10", bbox: [-87.637230, 24.520416, -79.722641, 31.002110] },
    { id_estado: "2-11", bbox: [-85.605507, 30.357130, -80.840927, 35.002041] },
    { id_estado: "2-12", bbox: [-164.706039, 18.909859, -154.805832, 23.579721] },
    { id_estado: "2-13", bbox: [-117.240196, 41.989841, -111.043617, 49.001522] },
    { id_estado: "2-14", bbox: [-91.512627, 36.971119, -87.018082, 42.509480] },
    { id_estado: "2-15", bbox: [-88.089737, 37.773052, -84.787666, 41.762321] },
    { id_estado: "2-16", bbox: [-96.635666, 40.374542, -90.139313, 43.504650] },
    { id_estado: "2-17", bbox: [-102.048546, 36.992222, -94.592743, 40.004509] },
    { id_estado: "2-18", bbox: [-89.573677, 36.496719, -81.964203, 39.147232] },
    { id_estado: "2-19", bbox: [-94.045776, 28.928333, -88.818138, 33.020599] },
    { id_estado: "2-2", bbox: [-179.150558, 51.209721, 179.773407, 71.390686] },
    { id_estado: "2-20", bbox: [-71.081795, 43.061668, -66.948891, 47.457642] },
    { id_estado: "2-21", bbox: [-79.487152, 37.892223, -75.050003, 39.724010] },
    { id_estado: "2-22", bbox: [-73.508408, 41.238335, -69.927498, 42.886662] },
    { id_estado: "2-23", bbox: [-90.418709, 41.695801, -82.122902, 48.304249] },
    { id_estado: "2-24", bbox: [-97.238983, 43.502102, -89.487747, 49.383297] },
    { id_estado: "2-25", bbox: [-91.654251, 30.174444, -88.097961, 34.998322] },
    { id_estado: "2-26", bbox: [-95.774406, 35.995090, -89.100586, 40.614029] },
    { id_estado: "2-27", bbox: [-116.050743, 44.357689, -104.039711, 49.001461] },
    { id_estado: "2-28", bbox: [-104.052841, 39.999889, -95.307999, 43.002800] },
    { id_estado: "2-29", bbox: [-120.005348, 35.002079, -114.039337, 42.000309] },
    { id_estado: "2-3", bbox: [-114.813827, 31.332280, -109.044876, 37.004589] },
    { id_estado: "2-30", bbox: [-72.556427, 42.697781, -70.600677, 45.308731] },
    { id_estado: "2-31", bbox: [-75.567596, 38.929977, -73.893631, 41.357639] },
    { id_estado: "2-32", bbox: [-109.050102, 31.332156, -103.000656, 36.999420] },
    { id_estado: "2-33", bbox: [-79.763329, 40.496170, -71.856354, 45.015831] },
    { id_estado: "2-34", bbox: [-84.320969, 33.841667, -75.461113, 36.589012] },
    { id_estado: "2-35", bbox: [-104.049591, 45.935051, -96.555153, 49.001221] },
    { id_estado: "2-36", bbox: [-84.819931, 38.402500, -78.853012, 42.961628] },
    { id_estado: "2-37", bbox: [-103.000870, 33.615250, -94.430702, 37.000931] },
    { id_estado: "2-38", bbox: [-124.566925, 41.992462, -116.461639, 46.292179] },
    { id_estado: "2-39", bbox: [-80.519562, 39.719429, -74.690033, 42.267879] },
    { id_estado: "2-4", bbox: [-94.618156, 33.004532, -89.644409, 36.499660] },
    { id_estado: "2-40", bbox: [-71.886963, 41.146877, -71.120613, 42.019100] },
    { id_estado: "2-41", bbox: [-83.354347, 32.049210, -78.546669, 35.216110] },
    { id_estado: "2-42", bbox: [-104.057129, 42.481110, -96.436577, 45.944359] },
    { id_estado: "2-43", bbox: [-90.310753, 34.983902, -81.647453, 36.679249] },
    { id_estado: "2-44", bbox: [-106.645782, 25.837107, -93.508743, 36.503441] },
    { id_estado: "2-45", bbox: [-114.054070, 36.998631, -109.040947, 42.004200] },
    { id_estado: "2-46", bbox: [-73.443428, 42.727612, -71.467712, 45.016262] },
    { id_estado: "2-47", bbox: [-83.674820, 36.539139, -75.242516, 39.466579] },
    { id_estado: "2-48", bbox: [-124.762779, 45.553112, -116.912506, 49.003590] },
    { id_estado: "2-49", bbox: [-82.640778, 37.202759, -77.719727, 40.638550] },
    { id_estado: "2-5", bbox: [-124.415558, 32.530884, -114.129486, 42.009830] },
    { id_estado: "2-50", bbox: [-92.885391, 42.494701, -86.249573, 47.302532] },
    { id_estado: "2-51", bbox: [-111.055138, 40.996269, -104.051987, 45.004200] },
    { id_estado: "2-6", bbox: [-109.060806, 36.992229, -102.041977, 41.005611] },
    { id_estado: "2-7", bbox: [-73.729721, 40.980011, -71.788239, 42.049732] },
    { id_estado: "2-8", bbox: [-75.788063, 38.427238, -75.049721, 39.840580] },
    { id_estado: "2-9", bbox: [-77.120506, 38.809174, -76.909698, 38.995060] },
    { id_estado: "3-1114", bbox: [-90.817436, 15.119660, -89.406296, 16.074859] },
    { id_estado: "3-1115", bbox: [-90.809044, 14.873028, -89.901985, 15.294077] },
    { id_estado: "3-1116", bbox: [-91.130546, 14.373420, -90.615630, 14.938703] },
    { id_estado: "3-1117", bbox: [-89.732208, 14.406201, -89.126739, 14.952419] },
    { id_estado: "3-1118", bbox: [-90.403436, 14.648487, -89.780600, 15.140331] },
    { id_estado: "3-1119", bbox: [-91.538894, 13.911251, -90.509065, 14.476392] },
    { id_estado: "3-1120", bbox: [-90.759567, 14.256638, -90.203483, 14.918847] },
    { id_estado: "3-1121", bbox: [-92.117970, 15.133957, -90.957412, 16.074363] },
    { id_estado: "3-1122", bbox: [-89.661545, 15.070316, -88.225669, 15.966529] },
    { id_estado: "3-1123", bbox: [-90.277755, 14.429879, -89.648347, 14.871861] },
    { id_estado: "3-1124", bbox: [-90.298776, 13.738282, -89.493751, 14.563304] },
    { id_estado: "3-1125", bbox: [-91.439758, 15.850934, -89.146157, 17.816618] },
    { id_estado: "3-1126", bbox: [-92.140014, 14.494301, -91.403557, 15.224425] },
    { id_estado: "3-1127", bbox: [-91.326164, 14.801934, -90.416092, 16.074257] },
    { id_estado: "3-1128", bbox: [-92.164291, 14.125710, -91.517418, 14.715660] },
    { id_estado: "3-1129", bbox: [-90.879996, 14.377621, -90.602929, 14.721912] },
    { id_estado: "3-1130", bbox: [-92.222359, 14.486251, -91.569220, 15.418221] },
    { id_estado: "3-1131", bbox: [-90.624200, 13.803267, -90.046920, 14.521225] },
    { id_estado: "3-1132", bbox: [-91.506645, 14.515317, -91.068503, 14.893421] },
    { id_estado: "3-1133", bbox: [-91.667786, 14.044810, -91.094292, 14.710862] },
    { id_estado: "3-1134", bbox: [-91.557342, 14.821034, -91.175315, 15.249397] },
    { id_estado: "3-1135", bbox: [-89.892998, 14.732496, -89.147735, 15.299085] },
    { id_estado: "4-404", bbox: [-88.618768, 17.036326, -87.485969, 17.969593] },
    { id_estado: "4-405", bbox: [-89.171021, 16.675024, -88.505729, 17.520993] },
    { id_estado: "4-406", bbox: [-88.563643, 17.874305, -87.827363, 18.496659] },
    { id_estado: "4-407", bbox: [-89.151965, 17.510464, -88.262513, 18.335186] },
    { id_estado: "4-408", bbox: [-88.655350, 16.441529, -87.769585, 17.169298] },
    { id_estado: "4-409", bbox: [-89.224175, 15.892658, -88.252082, 16.678609] },
    { id_estado: "5-1185", bbox: [-87.808685, 15.410252, -86.390983, 15.927638] },
    { id_estado: "5-1186", bbox: [-87.514305, 12.984540, -86.702546, 13.763494] },
    { id_estado: "5-1187", bbox: [-86.511803, 15.061209, -84.994019, 16.028194] },
    { id_estado: "5-1188", bbox: [-88.080452, 14.035908, -87.233735, 15.049070] },
    { id_estado: "5-1189", bbox: [-89.222221, 14.481278, -88.630478, 15.289088] },
    { id_estado: "5-1190", bbox: [-88.434402, 14.784558, -87.730652, 16.000140] },
    { id_estado: "5-1191", bbox: [-87.225197, 13.497464, -85.574813, 14.411851] },
    { id_estado: "5-1192", bbox: [-87.655876, 13.647803, -86.724197, 15.020077] },
    { id_estado: "5-1193", bbox: [-84.998115, 14.614528, -82.405693, 17.418473] },
    { id_estado: "5-1194", bbox: [-88.512154, 13.850329, -87.839775, 14.647224] },
    { id_estado: "5-1195", bbox: [-87.000137, 15.952084, -85.815697, 16.517084] },
    { id_estado: "5-1196", bbox: [-88.232605, 13.822763, -87.602433, 14.415311] },
    { id_estado: "5-1197", bbox: [-88.976952, 13.939386, -88.309455, 14.929739] },
    { id_estado: "5-1198", bbox: [-89.350792, 14.210661, -88.709336, 14.713985] },
    { id_estado: "5-1199", bbox: [-87.013611, 14.046360, -84.994019, 15.579617] },
    { id_estado: "5-1200", bbox: [-88.760924, 14.629146, -87.989227, 15.541819] },
    { id_estado: "5-1201", bbox: [-87.811860, 13.248195, -87.341567, 13.843180] },
    { id_estado: "5-1202", bbox: [-87.936677, 14.861682, -86.223961, 15.721937] },
    { id_estado: "6-2659", bbox: [-90.124862, 13.660685, -89.690659, 14.064374] },
    { id_estado: "6-2660", bbox: [-88.988357, 13.738312, -88.487442, 14.019086] },
    { id_estado: "6-2661", bbox: [-89.427154, 13.901993, -88.681159, 14.422705] },
    { id_estado: "6-2662", bbox: [-89.167634, 13.633469, -88.858512, 14.057421] },
    { id_estado: "6-2663", bbox: [-89.620414, 13.417916, -89.132362, 14.062419] },
    { id_estado: "6-2664", bbox: [-89.157884, 13.259010, -88.776329, 13.665380] },
    { id_estado: "6-2665", bbox: [-88.092711, 13.152640, -87.683745, 13.899358] },
    { id_estado: "6-2666", bbox: [-88.271965, 13.539756, -87.939339, 13.986462] },
    { id_estado: "6-2667", bbox: [-88.527397, 13.167247, -88.018838, 13.895736] },
    { id_estado: "6-2668", bbox: [-89.288895, 13.468975, -88.987548, 14.056671] },
    { id_estado: "6-2669", bbox: [-88.894158, 13.235694, -88.484848, 13.793494] },
    { id_estado: "6-2670", bbox: [-89.741677, 13.772410, -89.247962, 14.450551] },
    { id_estado: "6-2671", bbox: [-89.951248, 13.518193, -89.438782, 13.906029] },
    { id_estado: "6-2672", bbox: [-88.803437, 13.158751, -88.120697, 13.692082] },
    { id_estado: "7-2054", bbox: [-85.513527, 13.026807, -81.999864, 15.025910] },
    { id_estado: "7-2055", bbox: [-85.228264, 10.918702, -82.970140, 13.293742] },
    { id_estado: "7-2056", bbox: [-85.985992, 12.037051, -84.968110, 12.783634] },
    { id_estado: "7-2057", bbox: [-86.440529, 11.518689, -86.085420, 11.951141] },
    { id_estado: "7-2058", bbox: [-87.690970, 12.395694, -86.657088, 13.306297] },
    { id_estado: "7-2059", bbox: [-85.676383, 11.615304, -84.572121, 12.644794] },
    { id_estado: "7-2060", bbox: [-86.747627, 12.847484, -86.109138, 13.431935] },
    { id_estado: "7-2061", bbox: [-86.134934, 11.600893, -85.785515, 12.190209] },
    { id_estado: "7-2062", bbox: [-86.262292, 12.984376, -84.824645, 14.607237] },
    { id_estado: "7-2063", bbox: [-87.117654, 12.005663, -86.269592, 13.115759] },
    { id_estado: "7-2064", bbox: [-86.768271, 13.201589, -86.062455, 13.656657] },
    { id_estado: "7-2065", bbox: [-86.683449, 11.718200, -85.827781, 12.631010] },
    { id_estado: "7-2066", bbox: [-86.283957, 11.828770, -85.964334, 12.140574] },
    { id_estado: "7-2067", bbox: [-86.284149, 12.507351, -84.717170, 13.374095] },
    { id_estado: "7-2068", bbox: [-85.991875, 11.015094, -84.784874, 12.113457] },
    { id_estado: "7-2069", bbox: [-86.785194, 13.462233, -85.824784, 14.077060] },
    { id_estado: "7-2070", bbox: [-85.192992, 10.707542, -83.664613, 11.858178] },
    { id_estado: "7-2071", bbox: [-86.173989, 11.043717, -85.186585, 11.684893] },
    { id_estado: "8-704", bbox: [-85.432021, 9.830497, -84.155716, 11.079315] },
    { id_estado: "8-705", bbox: [-84.084801, 9.499815, -83.311652, 10.149781] },
    { id_estado: "8-706", bbox: [-85.960694, 9.732638, -84.770844, 11.216918] },
    { id_estado: "8-707", bbox: [-84.195533, 9.962646, -83.706574, 10.789644] },
    { id_estado: "8-708", bbox: [-83.942437, 9.062000, -82.553222, 10.938904] },
    { id_estado: "8-709", bbox: [-87.094865, 5.499027, -82.711806, 10.336080] },
    { id_estado: "8-710", bbox: [-84.592827, 9.079959, -83.425171, 10.191658] },
    { id_estado: "9-2157", bbox: [-82.938722, 8.827948, -81.915702, 9.616516] },
    { id_estado: "9-2158", bbox: [-83.050178, 7.859304, -81.507393, 8.919561] },
    { id_estado: "9-2159", bbox: [-80.822998, 8.087090, -80.052520, 9.063969] },
    { id_estado: "9-2160", bbox: [-80.876571, 8.632670, -79.080277, 9.647361] },
    { id_estado: "9-2161", bbox: [-78.512513, 7.218425, -77.173240, 9.092750] },
    { id_estado: "9-2162", bbox: [-78.337441, 7.581108, -77.239128, 8.777940] },
    { id_estado: "9-2163", bbox: [-80.963349, 7.510129, -80.366250, 8.131739] },
    { id_estado: "9-2164", bbox: [-79.282952, 8.523670, -77.357360, 9.600420] },
    { id_estado: "9-2165", bbox: [-80.738503, 7.227359, -79.991250, 8.004029] },
    { id_estado: "9-2166", bbox: [-82.445542, 8.145949, -81.132659, 9.186529] },
    { id_estado: "9-2167", bbox: [-80.170372, 7.999861, -78.048797, 9.523340] },
    { id_estado: "9-2168", bbox: [-82.264032, 7.202359, -80.614295, 9.000139] }
  ]
  let bbox = entidadBbox.find(item => item.id_estado == id)['bbox']
  mapRef.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]])
}
export const changeCombobox = (property, id) => {
  setToolsMap(property, id)
}